/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Stage_Trigger_HintInputs */

const cs_field_stage_trigger_hint = /** @type {(inputs: Field_Stage_Trigger_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spustit při vstupu do této fáze.`)
};

const en_field_stage_trigger_hint = /** @type {(inputs: Field_Stage_Trigger_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run when the record enters this stage.`)
};

/**
* | output |
* | --- |
* | "Run when the record enters this stage." |
*
* @param {Field_Stage_Trigger_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_stage_trigger_hint = /** @type {((inputs?: Field_Stage_Trigger_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Stage_Trigger_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_stage_trigger_hint(inputs)
	return cs_field_stage_trigger_hint(inputs)
});